// @core/api/endpoints/task/delete_task_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete numbering scheme
 * Deletes a task numbering scheme. Existing task numbers are not affected.
 */
export async function DeleteTaskNumberingScheme(
  scheme_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
